import React, { useCallback, useMemo, useState } from 'react';
import { StyleSheet, View, } from 'react-native';
import { ModalFlatList } from 'design-system/ModalScrollables';
import { rem } from 'design-system/values';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import useColors from 'hooks/useColors';
import { Button } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useScrollableModalMaxHeight } from 'hooks';
import { SpaceItem } from 'features/spaces/components';
import RadioButton from 'design-system/RadioButton';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { isWeb } from '../../../constants';
export const keyExtractor = (item) => item.id.toString();
export const SelectSpacesModalContent = ({ spacesToShow, hiddenAccounts, selectedSpaces, onScroll, onSave, onPressDisabled, }) => {
    const userId = useAppSelector(selectUserId);
    const spaces = useMemo(() => spacesToShow.map(({ space }) => space), [spacesToShow]);
    const [selected, setSelected] = useState(selectedSpaces);
    const onPress = useCallback(() => {
        if (!selected.length)
            return;
        onSave(selected);
        Modal.hide();
    }, [onSave, selected]);
    const onSelect = useCallback((item) => {
        setSelected((prev) => {
            const index = prev.findIndex((s) => s.id === item.id);
            const isSelected = index !== -1;
            if (isSelected) {
                return prev.filter((_, i) => i !== index);
            }
            return [...prev, item];
        });
    }, []);
    const colors = useColors();
    const renderItem = useCallback(({ item }) => {
        const isSelected = !!selected.find((s) => s.id === item.id);
        const isDisabled = !item.isDefault && !item.isPremium;
        const isOwner = item.createdBy === userId;
        return (<TouchableHighlight onCard hoverOnLight activeOpacity={1} disabled={isDisabled} onPress={isDisabled ? undefined : () => onSelect(item)} underlayColor={colors.background.underlay} style={styles.touchable}>
          <View style={styles.row}>
            <View pointerEvents="none" style={[
                isDisabled ? styles.disabled : undefined,
                styles.innerRow,
            ]}>
              <RadioButton type="multiple" isChecked={isSelected}/>
              <View style={styles.spaceItem}>
                <SpaceItem space={item}/>
              </View>
            </View>
            {!!isDisabled && (<Button title={isOwner ? 'Upgrade' : 'Action required'} {...(isOwner
                ? { brandReversed: true }
                : { errorReversed: true })} square hug onPress={() => onPressDisabled(item, isOwner)}/>)}
          </View>
        </TouchableHighlight>);
    }, [colors.background.underlay, onPressDisabled, onSelect, selected, userId]);
    const ListHeaderComponent = useMemo(() => hiddenAccounts ? (<Text TextThin-16 Secondary centered={!isWeb} style={styles.hiddenAccounts}>
          Spaces with no accounts are hidden
        </Text>) : null, [hiddenAccounts]);
    const maxHeight = useScrollableModalMaxHeight();
    const style = useMemo(() => ({ maxHeight }), [maxHeight]);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT + (isWeb ? 0 : rem(16)));
    return (<>
      <ModalFlatList data={spaces} onScroll={onScroll} scrollEventThrottle={16} renderItem={renderItem} style={style} keyExtractor={keyExtractor} contentContainerStyle={contentContainerStyle} ListHeaderComponent={ListHeaderComponent}/>
      <Button brand floating title="Save" disabled={!selected.length} onPress={onPress} containerStyle={styles.button}/>
    </>);
};
const styles = StyleSheet.create({
    button: {
        marginHorizontal: 0,
    },
    innerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: isWeb ? rem(8) : rem(16),
    },
    spaceItem: {
        flex: 1,
    },
    hiddenAccounts: {
        marginBottom: rem(8),
        marginHorizontal: rem(16),
    },
    disabled: {
        opacity: 0.5,
        // @ts-expect-error
        cursor: 'default',
    },
    touchable: {
        ...(isWeb && { marginHorizontal: rem(8) }),
    },
});
